import { combineReducers, configureStore } from "@reduxjs/toolkit";
import pinsReducer from "./Pins/PinsSlice";
import authReducer from "./Auth/AuthSlice";
import usersReducer from "./Users/UsersSlice";
import addvertismentReducer from "./Advertisement/AdvertismentSlice";
import storage from "redux-persist/lib/storage";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const allreducers = combineReducers({
  pins: pinsReducer,
  login: authReducer,
  users: usersReducer,
  advertisment: addvertismentReducer,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["login"],
};

const persistedReducer = persistReducer(persistConfig, allreducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
